import {
  FETCH_CURRENT_LOGIN_USER,
  FETCH_CURRENT_LOGIN_USER_SUCCESS,
  FETCH_CURRENT_LOGIN_USER_FAILURE,
  CLEAR_CURRENT_LOGIN_USER,
} from "../actions";

const initialState = {
  currentLoginUser: {},
  loading: true,
  err: null,
  haveData: false,
};

export const reducer = (state = initialState, action) => {
  //console.log(action)
  switch (action.type) {
    case FETCH_CURRENT_LOGIN_USER:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false,
      };
    case FETCH_CURRENT_LOGIN_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        haveData: true,
        currentLoginUser: action.data,
      };
    case FETCH_CURRENT_LOGIN_USER_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        currentLoginUser: {},
      };
    case CLEAR_CURRENT_LOGIN_USER:
      return initialState;
    default:
      return state;
  }
};
